<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          span 目前最低存量: {{ amount }}
          br
          span 請輸入欲重新設定之最低存量
          input.form-control(
            type="number" v-model="number" 
            @click="useNumPad"
            @keydown="useNumPad"
            min="0"
            )
          div.modal-footer
            button.btn.btn-primary(@click="confirm") 確定
            button.btn.btn-info(@click="cancel") 取消
    NumberInput(v-show="showPad" v-on:saveNumber="saveNumber" :defaultNumber="number")
</template>

<script>
import NumberInput from './NumberInput';

export default {
  name: 'ResetLowAmountLimit',
  props: {
    showNumPad: {
      type: Boolean,
      default: true,
    },
    currentAmount: {
      type: Number,
      default: undefined,
    },
    limitAmount: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      number: 0,
      showPad: false,
    };
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
    selectedDrugLowAmountLimitData() {
      return this.$store.getters.selectedDrugLowAmountLimitData;
    },
    selectedDrugTotalMax() {
      return this.$store.getters.selectedDrugTotalMax;
    },
    amount() {
      if (this.currentAmount) return this.currentAmount;
      return this.selectedDrugLowAmountLimitData.min_stock;
    },
    amountLimit() {
      if (this.limitAmount) return this.limitAmount;
      return this.selectedDrugTotalMax;
    },
  },
  components: {
    NumberInput,
  },
  methods: {
    useNumPad() {
      if (this.showNumPad) {
        this.showPad = true;
      }
    },
    saveNumber(val) {
      this.number = val;
      this.showPad = false;
    },
    cancel() {
      this.$emit('closeModal');
    },
    confirm() {
      if (this.number > this.amountLimit) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: `安全存量不可大於總最大庫存量: ${this.amountLimit}`,
          keepOnTop: true,
        });
      } else {
        this.instance.patch(`/api/total-storage-in-system/${this.selectedDrugLowAmountLimitData.id}/`, {
          min_stock: this.number,
        })
        .then((res) => {
          this.$emit('closeModal');
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '修改完成',
            keepOnTop: true,
          });
          this.$store.dispatch('getLowAmountLimitData', this.selectedDrugLowAmountLimitData.medication.id);
        });
      }
    },
  },
  watch: {
    number(val) {
      this.number = parseInt(val, 10);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ResetLowAmountLimit.vue?5238747c